import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@ownyou/ui-components';
import { useMission } from '../hooks/useMission';
import { MissionEvidencePanel } from '../components/missions/MissionEvidencePanel';

export function MissionEvidence() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { mission, isLoading } = useMission(id ?? '');

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-950 text-white p-4">
        <p className="text-sm text-slate-400">Loading evidence…</p>
      </div>
    );
  }

  if (!mission) {
    return (
      <div className="min-h-screen bg-slate-950 text-white p-4">
        <Button variant="secondary" onClick={() => navigate(-1)}>Back</Button>
        <p className="mt-4 text-sm text-slate-400">Mission evidence is unavailable.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="mx-auto max-w-3xl space-y-4 px-4 py-5">
        <Button variant="secondary" onClick={() => navigate(`/mission/${id}`)}>Back to mission</Button>
        <MissionEvidencePanel mission={mission as unknown as Record<string, unknown>} title="Evidence" />
      </div>
    </div>
  );
}
